import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { auth, database } from "../../utils/fipresConfig";
import { useAuthState } from "react-firebase-hooks/auth";
import { signOutUser } from "../../utils/fireStoreFunction";
import { FaUserTimes, FaHome, FaFolderOpen, FaChartPie, FaComments, FaUserCheck } from 'react-icons/fa';
import { MdAdminPanelSettings } from "react-icons/md";
import { doc, getDoc } from "firebase/firestore";
import "./navebr.css";

const Navbar = () => {
  const [user, loading] = useAuthState(auth);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isAdmin, setIsAdmin] = useState(false);

  const signOut = async () => {
    await signOutUser();
    window.location.reload(); // Reload the page after sign out
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
      setLastScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]);

  useEffect(() => {
    const fetchUserRole = async () => {
      if (user) {
        const docRef = doc(database, "users", user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const userData = docSnap.data();
          setIsAdmin(userData.isAdmin === true);
        }
      }
    };
    fetchUserRole();
  }, [user]);

  return (
    loading ? (
      <p className="loading">
        <svg className="loading_svg" viewBox="25 25 50 50">
          <circle className="loading_circal" r="20" cy="50" cx="50"></circle>
        </svg>
      </p>
    ) : (
      <nav id="navbar" className={isVisible ? "visible" : "hidden"}>
        <ul className="navbar-items flexbox-col">
          <li className="navbar-logo flexbox-left">
            <a className="navbar-item-inner flexbox" aria-label="Logo" href="#">
              <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 1438.88 1819.54">
                <polygon points="925.79 318.48 830.56 0 183.51 1384.12 510.41 1178.46 925.79 318.48"/>
                <polygon points="1438.88 1663.28 1126.35 948.08 111.98 1586.26 0 1819.54 1020.91 1250.57 1123.78 1471.02 783.64 1663.28 1438.88 1663.28"/>
              </svg>
            </a>
          </li>
          <li className="navbar-item flexbox-left">
            <Link to={"/"} className="navbar-item-inner flexbox-left" aria-label="Home">
              <div className="navbar-item-inner-icon-wrapper flexbox">
                <FaHome />
              </div>
              <span className="link-text">Home</span>
            </Link>
          </li>
          <li className="navbar-item flexbox-left">
            <Link to={"/project"} className="navbar-item-inner flexbox-left" aria-label="Projects">
              <div className="navbar-item-inner-icon-wrapper flexbox">
                <FaFolderOpen />
              </div>
              <span className="link-text">Projects</span>
            </Link>
          </li>
          <li className="navbar-item flexbox-left">
            <Link to="/files" className="navbar-item-inner flexbox-left" aria-label="Dashboard">
              <div className="navbar-item-inner-icon-wrapper flexbox">
                <FaChartPie />
              </div>
              <span className="link-text">Files</span>
            </Link>
          </li>
          {isAdmin && (
            <li className="navbar-item flexbox-left">
              <Link to="/admin" className="navbar-item-inner flexbox-left" aria-label="Admin">
                <div className="navbar-item-inner-icon-wrapper flexbox">
                  <MdAdminPanelSettings />
                </div>
                <span className="link-text">Admin</span>
              </Link>
            </li>
          )}
          {user && (
            <li className="navbar-item flexbox-left">
              <Link to={"/notes"} className="navbar-item-inner flexbox-left" aria-label="Notes">
                <div className="navbar-item-inner-icon-wrapper flexbox">
                  <FaComments />
                </div>
                <span className="link-text">Notes</span>
              </Link>
            </li>
          )}
          {user ? (
            <li className="navbar-item flexbox-left" id="nav_t">
              <Link to={"/authentication"} onClick={signOut} className="navbar-item-inner flexbox-left" aria-label="Sign Out">
                <div className="navbar-item-inner-icon-wrapper flexbox">
                  <FaUserCheck />
                </div>
                <span id="nav_t" className="link-text">Sign Out</span>
              </Link>
            </li>
          ) : (
            <li className="navbar-item flexbox-left">
              <Link to={"/authentication"} className="navbar-item-inner flexbox-left" aria-label="Register">
                <div className="navbar-item-inner-icon-wrapper flexbox">
                  <FaUserTimes />
                </div>
                <span id="nav_t" className="link-text">Register</span>
              </Link>
            </li>
          )}
        </ul>
      </nav>
    )
  );
};

export default Navbar;